var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner special-charge-window",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            "close-on-click-modal": false,
            width: "1000px",
            "before-close": _vm.cancel,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "left",
                    "label-width": "90px",
                    model: _vm.adjustCharge
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ChargeBranchId")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  value: _vm.branchOfficeName,
                                  disabled: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.ChargeItem") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "method-params": _vm.getChargeItemFilter(),
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_ChargeItem,
                                  "default-value":
                                    Number(_vm.adjustCharge.chargeItemId) || "",
                                  "options-width": "250px",
                                  "tag-value": "itemId",
                                  "tag-name": "zhName",
                                  disabled: !_vm.isEditing
                                },
                                on: { parentCallBack: _vm.onChangeCompany }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.AccountObject")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    Number(_vm.adjustCharge.accountId) || "",
                                  "method-params": { active: true },
                                  receivable: false,
                                  "auto-key": "auto_accountId",
                                  "data-filter-function": _vm.apAccountFilter,
                                  "options-width": "200px;",
                                  disabled: !_vm.isEditing,
                                  "tag-name": "chineseName"
                                },
                                on: {
                                  parentCallBack:
                                    _vm.textAccountCode_changeHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "FinanceManage.charge_invoiceHeader"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: true,
                                  "filter-type": "global",
                                  "allow-create": !_vm.settlementUnitOptional,
                                  "default-value":
                                    _vm.adjustCharge.invoiceTitle,
                                  disabled: !_vm.isEditing,
                                  "options-width": "200px;",
                                  "tag-value": "title",
                                  "tag-name": "title",
                                  "filter-tag-names": ["title"],
                                  "static-options": _vm.invoiceTitleList
                                },
                                on: {
                                  parentCallBack:
                                    _vm.textInvoiceTitleChangeHandle
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Unit") } },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_ChargeMeasure,
                                  filterable: "",
                                  clearable: false,
                                  "options-width": "100px",
                                  disabled: !_vm.isEditing,
                                  "method-params": { seaFreight: true },
                                  "default-value":
                                    _vm.adjustCharge.measure || ""
                                },
                                on: {
                                  parentCallBack: _vm.combMeasureChangeHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Quantity2") } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  max: 999999999,
                                  min: -999999999,
                                  precision: 3,
                                  controls: false,
                                  disabled: !_vm.isEditing
                                },
                                on: { change: _vm.txtQuantityChangeHandler },
                                model: {
                                  value: _vm.adjustCharge.quantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.adjustCharge, "quantity", $$v)
                                  },
                                  expression: "adjustCharge.quantity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.UnitRate") } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  max: 999999999,
                                  min: -999999999,
                                  precision: 3,
                                  controls: false,
                                  disabled: !_vm.isEditing
                                },
                                on: { change: _vm.txtUnitRateChangeHandler },
                                model: {
                                  value: _vm.adjustCharge.unitRate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.adjustCharge, "unitRate", $$v)
                                  },
                                  expression: "adjustCharge.unitRate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.ExchangeRate") }
                            },
                            [
                              _c("num-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  precision: 8,
                                  "truncated-precision":
                                    _vm.exchangeRatePrecision,
                                  max: 999999999,
                                  min: -999999999
                                },
                                model: {
                                  value: _vm.adjustCharge.exchangeRate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.adjustCharge,
                                      "exchangeRate",
                                      $$v
                                    )
                                  },
                                  expression: "adjustCharge.exchangeRate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Currency") } },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  clearable: false,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Currency,
                                  "default-value":
                                    _vm.adjustCharge.currency || "",
                                  "options-width": "100px",
                                  disabled: !_vm.isEditing
                                },
                                on: {
                                  parentCallBack: _vm.textCurrencyChangeHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.IsNeedInvoice")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  clearable: false,
                                  fields: ["value"],
                                  "callback-params": { key: "needInvoice" },
                                  "callback-method-type": "value",
                                  "default-value": _vm.adjustCharge.needInvoice,
                                  cache: false,
                                  "tag-value": "code",
                                  "tag-name": "value",
                                  "options-width": "100px",
                                  disabled: !_vm.isEditing,
                                  "static-options": [
                                    {
                                      code: false,
                                      value: _vm.$t("CargoMsg.Cargo_No")
                                    },
                                    {
                                      code: true,
                                      value: _vm.$t("CargoMsg.Cargo_Yes")
                                    }
                                  ],
                                  "filter-tag-names": ["value"]
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.adjustCharge.needInvoice =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: _vm.$t("SeaExport.Oversea") }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  clearable: false,
                                  fields: ["value"],
                                  "callback-params": { key: "oversea" },
                                  "callback-method-type": "value",
                                  "default-value": String(
                                    _vm.adjustCharge.oversea
                                  ),
                                  cache: false,
                                  "tag-value": "code",
                                  "tag-name": "value",
                                  disabled: !_vm.isEditing,
                                  "static-options": [
                                    {
                                      code: "false",
                                      value: _vm.$t("CargoMsg.Cargo_Domestic")
                                    },
                                    {
                                      code: "true",
                                      value: _vm.$t(
                                        "CargoMsg.Cargo_International"
                                      )
                                    }
                                  ],
                                  "filter-tag-names": ["value"],
                                  "options-width": "150px"
                                },
                                on: {
                                  parentCallBack: _vm.onChangeIsOverseaHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.IncludingTaxAmount")
                              }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  max: 999999999,
                                  min: -999999999,
                                  precision: 2,
                                  controls: false,
                                  disabled: !_vm.isEditing
                                },
                                on: { change: _vm.textAmountChangeHandler },
                                model: {
                                  value: _vm.adjustCharge.amount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.adjustCharge, "amount", $$v)
                                  },
                                  expression: "adjustCharge.amount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ExcludingTaxAmount")
                              }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  max: 999999999,
                                  min: -999999999,
                                  value: !_vm.needInvoiceNo
                                    ? _vm.adjustCharge.excludingTaxAmount
                                    : _vm.adjustCharge.amount,
                                  disabled: !_vm.isEditing,
                                  precision: 2,
                                  controls: false
                                },
                                on: {
                                  input: function(val) {
                                    _vm.adjustCharge.excludingTaxAmount = val
                                  },
                                  change: _vm.excludingTaxAmountChangeHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.BillAmount") }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  max: 999999999,
                                  min: -999999999,
                                  precision: 2,
                                  controls: false,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.adjustCharge.taxAmount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.adjustCharge, "taxAmount", $$v)
                                  },
                                  expression: "adjustCharge.taxAmount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.TaxRate") } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  max: 999999999,
                                  min: -999999999,
                                  value: isNaN(_vm.adjustCharge.taxRate)
                                    ? "0"
                                    : _vm.adjustCharge.taxRate,
                                  precision: 2,
                                  controls: false,
                                  disabled: !_vm.isEditing
                                },
                                on: {
                                  input: function(val) {
                                    _vm.adjustCharge.taxRate = val
                                  },
                                  change: _vm.txtRateChangeHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea", rows: 5 },
                                model: {
                                  value: _vm.adjustCharge.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.adjustCharge, "remarks", $$v)
                                  },
                                  expression: "adjustCharge.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.saveEvent }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }